export class PropertiesInterfaceDependenciesNotSatisifiedError extends Error {}
